class PolyfilledFile extends Blob {
  lastModifiedDate: Date;

  lastModified: string;

  name: string;

  constructor(chunks: any[], filename: string, opts: BlobPropertyBag = {}) {
    super(chunks, opts);
    this.lastModifiedDate = new Date();
    this.lastModified = this.lastModifiedDate.toString();
    this.name = filename;
  }
}

export type FileTypes = PolyfilledFile | File;

// eslint-disable-next-line import/no-mutable-exports
let FileConstructor: typeof File;

try {
  new File([], ''); // eslint-disable-line no-new

  FileConstructor = File;
} catch (e) {
  // We cast `PolyfilledFile` to `File` through `unknown`,
  // so that TS treats `PolyfilledFile` instances as if they are
  // `File` instances. They're basically the same thing! We promise!
  FileConstructor = PolyfilledFile as unknown as typeof File;
}

export default FileConstructor;
